export enum PassportStatusCodes {
  OPEN = 1,
  AWAITING_APPROVAL,
  AWAITING_APPROVAL_OF_ADMIN_MANAGER,
  AWAITING_APPROVAL_OF_CFO,
  UNDER_PROCESS_WITH_PRO,
  READY_TO_ISSUE,
  Rejected,
  CANCELLED,
  ISSUED,
  AWAITING_APPROVAL_OF_PAYROLL_ADMIN,
  COLLECTED,
  AWAITING_APPROVAL_OF_FINANCE_MANAGER,
}
